import { stockRequestBody } from "./stockContext";


import { apiFetch } from "./apiFetch";

export async function getArkBuyTradesSource(serverUrl, stockSession) {
  const resp = await apiFetch(`${serverUrl}/getArkBuyTradesSource`, {
    method: "POST",
    body: JSON.stringify(stockRequestBody(stockSession)),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || data.error || "Failed to load ARK ETF source");
  }
  return data;
}

export async function listStockArkBuy(serverUrl, stockSession) {
  const resp = await apiFetch(`${serverUrl}/listStockArkBuy`, {
    method: "POST",
    body: JSON.stringify(stockRequestBody(stockSession)),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || data.error || "Failed to load ARK ETF list");
  }
  const rows = Array.isArray(data.rows) ? data.rows : [];
  const totalMatched =
    data.totalMatched != null && Number.isFinite(Number(data.totalMatched))
      ? Number(data.totalMatched)
      : rows.length;
  return {
    rows,
    totalMatched,
    fetchedAt: data.fetchedAt || "",
    sourceUrl: data.sourceUrl || data.tradesUrl || "",
    tradesUrl: data.tradesUrl || data.sourceUrl || "",
    holdingsUrl: data.holdingsUrl || "",
  };
}
